<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 48 48">
    <title>{{title }}</title>
    <g :fill="fill">
      <path d="M32.57,33.512c-0.507,0.647-1.007,1.265-1.493,1.851C39.13,36.212,44,38.391,44,40 c0,2.039-7.791,5-20,5S4,42.039,4,40c0-1.609,4.87-3.788,12.923-4.637c-0.486-0.586-0.986-1.205-1.493-1.851 C7.949,34.442,2,36.631,2,40c0,4.596,11.067,7,22,7s22-2.404,22-7C46,36.631,40.051,34.442,32.57,33.512z"></path>
      <path d="M24,1C16.627,1,9,6.611,9,16c0,8.95,13.707,22.866,14.29,23.455c0.188,0.189,0.443,0.295,0.71,0.295 s0.522-0.106,0.71-0.295C25.293,38.866,39,24.95,39,16C39,6.611,31.373,1,24,1z M24,21c-2.757,0-5-2.243-5-5s2.243-5,5-5 s5,2.243,5,5S26.757,21,24,21z"></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Truck",
  props: {
    title: {
      default: 'Livraison',
      type: String,
    },
    fill: {
      default: 'currentColor',
      type: String,
    },
    size: {
      type: Number,
      default: 14,
    },
  },
}
</script>
